var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fx hll-radio-box",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"hll-radio-temp",class:{ selected: _vm.checked }})])}
var staticRenderFns = []

export { render, staticRenderFns }